import { forEach, includes, keys } from "ramda";

export default function getSections(availability) {
  const sectionKeys = [];
  forEach(a => forEach(k => {
    if (!includes(k, sectionKeys)) {
      sectionKeys.push(k);
    }
  },keys(a.sectionTime)), availability)

  return sectionKeys;
}